import { render, staticRenderFns } from "./navCatalogue.vue?vue&type=template&id=a1cd89b8&"
import script from "./navCatalogue.vue?vue&type=script&lang=js&"
export * from "./navCatalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.6_uc55t47uxtlogncefk63ylt2rm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports